import { render, staticRenderFns } from "./ManageAdmin.vue?vue&type=template&id=6bed330c&scoped=true&"
import script from "./ManageAdmin.vue?vue&type=script&lang=js&"
export * from "./ManageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ManageAdmin.vue?vue&type=style&index=0&id=6bed330c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed330c",
  null
  
)

export default component.exports